module.exports = __webpack_public_path__ + "img/ms.d5390a0.svg";